import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_1949873244 from "../../../../../packages/component/src/components/input/demo/demo1.js?loadDemo";
import legacyImportDemo_3063710655 from "../../../../../packages/component/src/components/input/demo/demo2.js?loadDemo";
import legacyImportDemo_3745886702 from "../../../../../packages/component/src/components/input/demo/demo12.js?loadDemo";
import legacyImportDemo_319420655 from "../../../../../packages/component/src/components/input/demo/demo13.js?loadDemo";
import legacyImportDemo_1604900382 from "../../../../../packages/component/src/components/input/demo/demo3.js?loadDemo";
import legacyImportDemo_232975225 from "../../../../../packages/component/src/components/input/demo/demo4.js?loadDemo";
import legacyImportDemo_1885762776 from "../../../../../packages/component/src/components/input/demo/demo5.js?loadDemo";
import legacyImportDemo_3086417979 from "../../../../../packages/component/src/components/input/demo/demo6.js?loadDemo";
import legacyImportDemo_3033386650 from "../../../../../packages/component/src/components/input/demo/demo7.js?loadDemo";
import legacyImportDemo_3317722101 from "../../../../../packages/component/src/components/input/demo/demo8.js?loadDemo";
import legacyImportDemo_445509480 from "../../../../../packages/component/src/components/input/demo/demo14.js?loadDemo";
import legacyImportDemo_483291476 from "../../../../../packages/component/src/components/input/demo/demo9.js?loadDemo";
import legacyImportDemo_1074166636 from "../../../../../packages/component/src/components/input/demo/demo10.js?loadDemo";
import legacyImportDemo_3964076653 from "../../../../../packages/component/src/components/input/demo/demo11.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_1949873244,
  legacyImportDemo_3063710655,
  legacyImportDemo_3745886702,
  legacyImportDemo_319420655,
  legacyImportDemo_1604900382,
  legacyImportDemo_232975225,
  legacyImportDemo_1885762776,
  legacyImportDemo_3086417979,
  legacyImportDemo_3033386650,
  legacyImportDemo_3317722101,
  legacyImportDemo_445509480,
  legacyImportDemo_483291476,
  legacyImportDemo_1074166636,
  legacyImportDemo_3964076653,
  React
};